/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import getColor from "@insite/mobius/utilities/getColor";
import CaretDown from "@monsma/XDL/Icons/CaretDown";
import { xBaseTheme } from "@monsma/XDL/types";
import { css } from "styled-components";

export default {
    defaultProps: {
        iconProps: {
            src: CaretDown,
            size: 13,
            color: "common.ui10",
            css: css`
                &&& {
                    width: 35px;
                }
            `,
        },
        css: css`
            &&&& {
                background: ${getColor("common.ui8")};
                overflow: hidden !important;
                text-overflow: ellipsis;
              
              &, &:focus {
                padding-right: 27px;
              }
            }
        `,
    },
} as xBaseTheme["select"];
